import React, { useState } from "react";
import "../styles/Register.css";
import registerImg from "../assets/img/bg_1.jpg";
import { FaPaperPlane, FaEye, FaEyeSlash } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const { handleRegister } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Form validation
  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;
    let invalidFields = [];

    // console.log(formData)

    const firstName = formData.firstName.trim();
    const lastName = formData.lastName.trim();
    const email = formData.email.trim().toLowerCase();
    const phone = formData.phone.trim();
    const password = formData.password.trim();
    const confirmPassword = formData.confirmPassword.trim();

    if (!firstName) invalidFields.push("firstName");
    if (!lastName) invalidFields.push("lastName");
    if (!email || !emailRegex.test(email)) invalidFields.push("email");
    if (!phone) invalidFields.push("phone");
    if (!password || password.length < 6) invalidFields.push("password");
    if (!confirmPassword || password !== confirmPassword)
      invalidFields.push("confirmPassword");
    // console.log(invalidFields)

    if (invalidFields.length > 0) {
      toast.error(
        `The following fields are invalid or empty: ${invalidFields.join(", ")}`
      );
      return false;
    }
    return true;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    // Correct payload with `email`
    const payload = {
      firstName: formData.firstName.trim(),
      lastName: formData.lastName.trim(),
      email: formData.email.trim(), // FIXED
      phoneNo: formData.phone.trim(),
      password: formData.password.trim(),
      confirmPassword: formData.confirmPassword.trim(),
    };

    // console.log("Register Payload:", payload);

    const response = await handleRegister(payload);
    setLoading(false);

    if (response.success) {
      toast.success("Registration successful! Redirecting...");
      setTimeout(() => navigate("/login"), 1000);
    } else {
      toast.error(response.message || "Registration failed.");
    }
  };

  return (
    <div className="register-wrapper">
      <div className="register-bg">
        <img src={registerImg} alt="Register" />
      </div>

      <div className="register-form-container flip-in-left">
        <h3 className="form-title">Register Now</h3>
        <form className="register-form" onSubmit={handleSubmit}>
          <div className="floating-input">
            <input
              type="text"
              id="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
            <label htmlFor="firstName">First Name</label>
          </div>

          <div className="floating-input">
            <input
              type="text"
              id="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
            <label htmlFor="lastName">Last Name</label>
          </div>

          <div className="floating-input">
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label htmlFor="email">Email Address</label>
          </div>

          <div className="floating-input">
            <input
              type="tel"
              id="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <label htmlFor="phone">Phone Number</label>
          </div>

          {/* Password Field */}
          <div className="floating-input password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={formData.password}
              onChange={handleChange}
              onFocus={() => setFocusedField("password")}
              onBlur={() => setFocusedField(null)}
              required
            />
            <label htmlFor="password">Password</label>
            {(focusedField === "password" || formData.password) && (
              <span
                className="password-toggle-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            )}
          </div>

          {/* Confirm Password Field */}
          <div className="floating-input password-wrapper">
            <input
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              onFocus={() => setFocusedField("confirmPassword")}
              onBlur={() => setFocusedField(null)}
              required
            />
            <label htmlFor="confirmPassword">Confirm Password</label>
            {(focusedField === "confirmPassword" || formData.confirmPassword) && (
              <span
                className="password-toggle-icon"
                onClick={() =>
                  setShowConfirmPassword(!showConfirmPassword)
                }
              >
                {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            )}
          </div>

          <div className="d-flex justify-content-between align-items-center mt-2">
            <p className="mb-0">
              Already have an account? <a href="/login">Sign In</a>
            </p>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "..." : <FaPaperPlane />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
